/**
 * Constants for ModelConfiguration component
 */

import { ModelParameters } from '../types';

// Available model types
export const MODEL_TYPES = [
  'Dense',
  'CNN',
  'LSTM',
  'AR LSTM',
  'SVR_dir',
  'SVR_MIMO',
  'LGBMR',
  'LIN'
] as const;

// Available activation functions for neural networks
export const ACTIVATION_FUNCTIONS = [
  'ReLU',
  'Sigmoid',
  'Tanh',
  'Linear',
  'Softmax',
  'None'
] as const;

// Available kernel types for SVR
export const KERNEL_TYPES = [
  'linear',
  'poly',
  'rbf',
  'sigmoid'
] as const;

// Neural network model types
export const NEURAL_NETWORK_MODELS = ['Dense', 'CNN', 'LSTM', 'AR LSTM'] as const;

// SVR model types
export const SVR_MODELS = ['SVR_dir', 'SVR_MIMO'] as const;

// LGBMR model types
export const LGBMR_MODELS = ['LGBMR'] as const;

/**
 * Get default parameters for each model type (user must fill in)
 */
export const getDefaultParams = (modelType: string): ModelParameters => {
  const baseParams: ModelParameters = { MODE: modelType };

  switch (modelType) {
    case 'Dense':
      return {
        ...baseParams,
        LAY: undefined,
        N: undefined,
        EP: undefined,
        ACTF: ''
      };
    case 'CNN':
      return {
        ...baseParams,
        LAY: undefined,
        N: undefined,
        K: undefined,
        EP: undefined,
        ACTF: ''
      };
    case 'LSTM':
    case 'AR LSTM':
      return {
        ...baseParams,
        LAY: undefined,
        N: undefined,
        EP: undefined,
        ACTF: ''
      };
    case 'SVR_dir':
    case 'SVR_MIMO':
      return {
        ...baseParams,
        KERNEL: '',
        C: undefined,
        EPSILON: undefined
      };
    case 'LGBMR':
      return {
        ...baseParams,
        N_ESTIMATORS: undefined,
        LEARNING_RATE: undefined,
        MAX_DEPTH: undefined
      };
    case 'LIN':
      return baseParams; // Linear model has minimal configuration
    default:
      return baseParams;
  }
};
